import React, { useEffect, useState } from 'react'
import { css, StyleSheet } from 'aphrodite'
import { COLOR_WHITE, COLOR_GRAY__100 } from '../../lib/colors'
import { useTranslation } from 'react-i18next'
import UIBackButton from '../../components/UI/UIBackButton'
import { useParams } from 'react-router-dom'
import { useLazyQuery } from '@apollo/client'
import GET_ONE_REQUEST from '../../graphql/Requests/queries/GetOneRequest'
import Map from '../../components/Map/Map'
import { DateTime } from 'luxon'
import Geocode from 'react-geocode'
import config from '../../config'
import { MEDIA_MIN_SM } from '../../lib/breakpoints'

const styles = StyleSheet.create({
  container: {
    padding: '16px',
  },
  detailContainer: {
    backgroundColor: COLOR_WHITE,
    borderRadius: '10px',
    paddingBottom: '20px',
  },
  requestTitle: {
    padding: '18px 24px',
    borderWidth: '0 0 1px 0',
    borderStyle: 'solid',
    borderColor: COLOR_GRAY__100,
  },
  requestBody: {
    [MEDIA_MIN_SM]: {
      paddingLeft: '65px',
    },
    display: 'flex',
    flexDirection: 'column',
  },
  detailRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    alignItems: 'center',
  },
  detailColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  labelTitle: {
    fontWeight: '600',
    fontSize: '14px',
    whiteSpace: 'nowrap',
  },
})

const RequestDetail = () => {
  Geocode.setApiKey(config.GOOGLE_APP_KEY)
  const { t } = useTranslation('requestDetail')
  const containerStyle = {
    width: window.innerWidth > 480 ? '650px' : '100%',
    height: '354px',
  }

  const [request, setRequest] = useState()
  const [loading, setLoading] = useState(true)

  const [location, setLocation] = useState({
    lat: null,
    lng: null,
  })

  const { requestId } = useParams()

  const [getRequest] = useLazyQuery(GET_ONE_REQUEST, {
    onCompleted: (data) => {
      setRequest(data.request)
      setLocation({
        lat: data.request.location.x,
        lng: data.request.location.y,
      })
      setLoading(false)
    },
  })

  const getRequestDate = (dateBegin, dateEnd) => {
    if (dateBegin && dateEnd) {
      const d1 = DateTime.fromISO(dateBegin)
      const d2 = DateTime.fromISO(dateEnd)

      if (d1.day === d2.day && d1.month === d2.month && d1.year === d2.year)
        return `${DateTime.fromISO(dateBegin).toLocaleString({
          month: 'long',
          day: 'numeric',
          year: 'numeric',
        })} ${t('at')} ${DateTime.fromISO(dateBegin).toFormat('HH:mm')} ${t(
          'to'
        )} ${DateTime.fromISO(dateEnd).toFormat('HH:mm')}`
      else {
        return `${DateTime.fromISO(dateBegin).toLocaleString({
          month: 'long',
          day: 'numeric',
          year: 'numeric',
        })} ${t('at')} ${DateTime.fromISO(dateBegin).toFormat('HH:mm')} ${t(
          'to'
        )} ${DateTime.fromISO(dateEnd).toLocaleString({
          month: 'long',
          day: 'numeric',
          year: 'numeric',
        })} ${t('at')} ${DateTime.fromISO(dateEnd).toFormat('HH:mm')}`
      }
    }
    return ''
  }

  useEffect(() => {
    getRequest({
      variables: {
        idRequest: requestId,
      },
    })
  }, [requestId])

  return (
    <div className={css(styles.container)}>
      <div className={css(styles.detailContainer)}>
        <div className={css(styles.requestTitle)}>
          <p>{t('requestInformation')}</p>
        </div>
        <div className={css(styles.requestBody)}>
          <UIBackButton />
          <div className={css(styles.detailRow)}>
            <p className={css(styles.labelTitle)}>{t('title')}</p>
            <p>{request?.title}</p>
          </div>
          <div className={css(styles.detailColumn)}>
            <p className={css(styles.labelTitle)}>{t('description')}</p>
            <p>{request?.summary}</p>
          </div>
          <div className={css(styles.detailRow)}>
            <p className={css(styles.labelTitle)}>{t('requestDate')}</p>
            <p>
              {getRequestDate(
                request?.datetimeRange.start.value,
                request?.datetimeRange.end.value
              )}
            </p>
          </div>
          <div className={css(styles.detailRow)}>
            <p className={css(styles.labelTitle)}>{t('address')}</p>
            <p>{request?.requestAddress}</p>
          </div>
          {!loading && (
            <Map
              apiAlreadyLoaded={true}
              center={location}
              containerStyle={containerStyle}
              zoom={15}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default RequestDetail
